import Authorize from './Authorize.component';

export default Authorize;
